export default function authHeader() {
    let access_token = localStorage.getItem("accessToken")
    if ( !access_token  ) {
        return null
    }
    return "Bearer " + access_token

}